<template>
  <!-- 入库单详情 -->
  <div class="form">
    <div class="container">
      <!-- 上方表单 -->
      <el-form :model="formData" label-width="130px">
        <el-row>
          <el-col span="6">
            <el-form-item label="项目名称：" prop="projectId" required>
              <el-select style="width: 100%" v-model="formData.projectId" disabled>
                <el-option
                  v-for="(item, index) in projectList"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="6">
            <el-form-item label="入库单号：" prop="inboundNo">
              <el-input v-model="formData.inboundNo" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col span="6">
            <el-form-item label="入库类型：" prop="type" required>
              <el-select style="width: 100%" v-model="formData.type" disabled>
                <el-option
                  v-for="(item, index) in typeList"
                  :key="index"
                  :label="item.dictValue"
                  :value="item.dictKey"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <template v-if="orderType == 1 || orderType == 4">
            <el-col span="6">
              <el-form-item label="入库仓库：" prop="warehouseId" required>
                <el-select style="width: 100%" v-model="formData.warehouseId" disabled>
                  <el-option
                    v-for="(item, index) in warehouseList"
                    :key="index"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </template>
          <template v-if="orderType == 2">
            <el-col span="6">
              <el-form-item label="调拨出库单号：" prop="linkNo" required>
                <el-input v-model="formData.linkNo" :readonly="true" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col span="6">
              <el-form-item label="调入仓库：" prop="destWarehouseId">
                <el-select style="width: 100%" v-model="formData.destWarehouseId" disabled>
                  <el-option
                    v-for="(item, index) in warehouseList"
                    :key="index"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col span="6">
              <el-form-item label="调出仓库：" prop="originWarehouseId">
                <el-select style="width: 100%" v-model="formData.originWarehouseId" disabled>
                  <el-option
                    v-for="(item, index) in warehouseList"
                    :key="index"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </template>
          <el-col span="6">
            <el-form-item label="经办人：" prop="handleUser">
              <el-input v-model="formData.handleUser" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col span="6">
            <el-form-item label="联系电话：" prop="tel">
              <el-input v-model="formData.tel" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="备注说明：" prop="remark">
          <el-input type="textarea" :rows="3" v-model="formData.remark" disabled />
        </el-form-item>
      </el-form>
      <hr />
      <!-- 物料区域 -->
      <h3>物料明细</h3>
      <avue-crud
        :option="goodsTableOption"
        :data="goodsTableData"
        :page.sync="goodsTablePage"
        @on-load="loadGoodsPageData"
      >
        <template slot="stockPrice" slot-scope="{ row }">
          {{ tool.money_format_allowvoid(row.stockPrice) }}
        </template>
        <template slot="inboundPrice" slot-scope="{ row }">
          {{ tool.money_format_allowvoid(row.inboundPrice) }}
        </template>
      </avue-crud>
      <div class="sum-tips" v-if="formData">
        <div style="color: red;">小数位数：单价2位，金额2位，超出部分将四舍五入</div>
        <div>
          合计本次入库数量：<span style="color: blue;">{{ formData.quantityNum }}</span
          >&nbsp;&nbsp;合计金额：<span style="color: red;">{{ formData.inboundAmount }}</span>
        </div>
      </div>
      <hr />
      <!-- 附件区域 -->
      <h3>附件</h3>
      <avue-crud :option="attachTableOption" :data="attachList">
        <template slot="operate" slot-scope="{ row }">
          <i class="el-icon-download" style="cursor: pointer;" @click="downloadAttach(row)"></i>
        </template>
        <template slot="extension" slot-scope="{ row }">
          <i
            v-if="['.png', '.jpg', '.jpeg'].includes(row.extension)"
            class="el-icon-picture-outline"
          ></i>
          <i
            v-else-if="['.xlx', '.xlsx', '.doc', '.docx', '.ppt', '.pptx'].includes(row.extension)"
            class="el-icon-document"
          ></i>
          <i v-else class="el-icon-folder"></i>
        </template>
      </avue-crud>
    </div>
  </div>
</template>

<script>
import { getProjectListApi, getDictApi, getWarehouseListApi } from '@/api/warehouse/index';
import { getDetailApi, getGoodListByInOrderApi } from '@/api/warehouse/in';
import { downloadFile } from '@/api/crmedical/contract/add';

export default {
  name: 'WarehouseInForm',
  props: ['projectId', 'orderId', 'orderType'],
  data() {
    return {
      // 项目列表
      projectList: [],
      // 仓库列表
      warehouseList: [],
      // 入库状态列表
      typeList: [],
      // 上方表单数据
      formData: {
        projectId: '',
        warehouseId: '',
        type: '',
      },
      // 附件列表
      attachList: [],
      // 物料明细的总列表数据
      goodsListData: [],
      // 物料明细的单页表格数据
      goodsTableData: [],
      // 物料明细的表格分页信息
      goodsTablePage: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      // 物料明细的表格配置项
      goodsTableOption: {
        height: 'auto',
        calcHeight: 'auto',
        border: true,
        refreshBtn: false,
        columnBtn: false,
        index: true,
        addBtn: false,
        menu: false,
        dialogClickModal: false,
        column: [
          {
            label: '物料类型',
            prop: 'typeName',
          },
          {
            label: '物料编码',
            prop: 'code',
          },
          {
            label: '物料名称',
            prop: 'name',
          },
          {
            label: '规格型号',
            prop: 'specification',
          },
          {
            label: '计量单位',
            prop: 'measuringUnitName',
          },
          {
            label: '单价',
            prop: 'stockPrice',
            align: 'right',
            slot: true,
          },
          {
            label: '入库数量',
            prop: 'inboundNum',
          },
          {
            label: '换算数量',
            prop: 'conversionNum',
          },
          {
            label: '本次入库金额',
            prop: 'inboundPrice',
            align: 'right',
            slot: true,
          },
          {
            label: '备注',
            prop: 'remark',
          },
        ],
      },
      // 附件的表格配置项
      attachTableOption: {
        height: 'auto',
        calcHeight: 'auto',
        index: true,
        border: true,
        dialogClickModal: false,
        refreshBtn: false,
        columnBtn: false,
        addBtn: false,
        menu: false,
        column: [
          {
            label: '操作',
            prop: 'operate',
            slot: true,
          },
          {
            label: '缩略图',
            prop: 'extension',
            slot: true,
          },
          {
            label: '附件名称',
            prop: 'originalName',
          },
          {
            label: '上传时间',
            prop: 'createTime',
          },
          {
            label: '上传人',
            prop: 'userName',
          },
        ],
      },
    };
  },
  created() {
    this.initData();
  },
  methods: {
    /* 初始化数据 */
    initData() {
      // 获取项目列表
      getProjectListApi().then(({ data }) => {
        this.projectList = data || [];
      });
      // 获取仓库列表
      getWarehouseListApi({
        projectId: this.projectId,
      }).then(({ data }) => {
        this.warehouseList = data || [];
      });
      // 获取入库状态列表
      getDictApi({
        code: 'warehouse_inbound_type',
      }).then(({ data }) => {
        this.typeList = data || [];
      });
      // 获取详情（表单+附件列表）
      getDetailApi({
        id: this.orderId,
      }).then(({ data }) => {
        this.attachList = data.inboundFileUrlList;
        this.formData = data;
        this.formData.type += ''; // 需要转换成字符串，否则会显示异常
      });
      // 获取物料列表
      getGoodListByInOrderApi({
        inboundId: this.orderId,
      }).then(({ data }) => {
        this.goodsListData = data;
        this.goodsTablePage.total = this.goodsListData.length;
        this.goodsTablePage.currentPage = 1;
        this.loadGoodsPageData();
      });
    },
    /* 加载物料列表的单页表格数据 */
    loadGoodsPageData() {
      if (this.goodsListData.length == 0) return;
      let index = (this.goodsTablePage.currentPage - 1) * this.goodsTablePage.pageSize;
      this.goodsTableData = this.goodsListData.slice(index, index + this.goodsTablePage.pageSize);
    },
    /* 下载附件 */
    downloadAttach(row) {
      downloadFile(row.link, row.originalName);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../dialog-form.scss';

hr {
  margin: 30px 0;
}

/* 去掉表格上方的空白区域 */
::v-deep .avue-crud__menu {
  display: none !important;
}
/* 图标大小 */
i[class^='el-icon'] {
  font-size: 20px;
}

.sum-tips {
  display: flex;
  justify-content: space-between;
}
</style>
